module.exports = __webpack_public_path__ + "img/2028.74ffd59c.svg";